import { type ApiClient, createApiClient } from '@budovan/api-client';
import { currentToken } from './auth.ts';

let client: ApiClient | null = null;

export function initApi(baseUrl: string): void {
  client = createApiClient({ baseUrl, getToken: currentToken });
}

export function api(): ApiClient {
  if (!client) throw new Error('initApi was not called');
  return client;
}

/** openapi-fetch returns { data, error }; screens want the data or a thrown Problem. */
export async function unwrap<T>(call: Promise<{ data?: T; error?: unknown }>): Promise<T> {
  const { data, error } = await call;
  if (error !== undefined) throw error;
  return data as T;
}
